import React from 'react'
import Richtext from '@/lib/rt/Richtext'
import Img from '@/lib/Img'

/* http://jquense.github.io/react-big-calendar/examples/?path=/docs/props--components */

const EventUrl = ({ url, className }) => !!url && (
	<p><a className={className} href={url} target="_blank">View details</a></p>
)

/* month */

const MonthDateHeader = ({ date }) => (
	<time
		className="block text-left text-2xl px-1"
		dateTime={date.toISOString().split(/T/)[0]}
	>
		{date.getDate()}
	</time>
)

const MonthEvent = ({ title, event }) => {
	const start = new Date(event.start)
	const end = new Date(event.end)

	const formatted = date => format(date, {
		month: 'short',
		day: 'numeric',
		weekday: 'short',
	})

	const start_formatted = formatted(start)
	const end_formatted = formatted(end)

	return (
		<article className="whitespace-normal">
			<h2 className="text-sm">{title}</h2>
			<p className="text-xs font-light">
				{[
					start_formatted,
					(end_formatted !== start_formatted) && end_formatted
				].filter(Boolean).join(' - ')}
			</p>
			<EventUrl className="link-hover text-orange text-xs" {...event} />
		</article>
	)
}

/* agenda */

const AgendaDate = ({ day }) => (
	<time className="grid text-center">
		<small>{format(day, { month: 'short' })}</small>
		<b className="text-3xl font-serif">{format(day, { day: 'numeric' })}</b>
		<small>{format(day, { weekday: 'short' })}</small>
	</time>
)

const AgendaEvent = ({ event }) => (
	<article className="grid md:grid-cols-[1fr,auto] gap-4 text-sm">
		<div className="richtext-sm">
			<h2 className="h3">{event.title}</h2>

			{!!event.type && (
				<p><small className="technical">{event.type}</small></p>
			)}

			<Richtext raw={event._rawRichtext} />
			<EventUrl className="link text-orange" {...event} />
		</div>

		<figure className="max-w-[200px]">
			<Img image={event.image} alt={event.title} />
		</figure>
	</article>
)

export default {
	month: {
		dateHeader: MonthDateHeader,
		event: MonthEvent,
	},
	agenda: {
		date: AgendaDate,
		event: AgendaEvent,
	},
}

const format = (date, options) => new Intl.DateTimeFormat('en-US', options).format(date)
